import { useMemo} from "react";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { PanelMenu } from "primereact/panelmenu";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { buildCatalogPath } from "../../../shared/utils/topbarUtils";

const CatalogFiltersSidebar = ({
    menuStructure = [],
    currentCollection = "",
    currentSubcollection = "",
    onNavigate,
    priceMin = "",
    priceMax = "",
    onlyInStock = false,
    onlyDiscounted = false,
    attributeGroups = [],
    selectedAttributeFilters = {},
    showDynamicAttributes = false,
    attributesLoading = false,
    attributesError = "",
    hasActiveFilters = false,
    onPriceMinChange,
    onPriceMaxChange,
    onOnlyInStockChange,
    onOnlyDiscountedChange,
    onAttributeToggle,
    onClear,
    }) => {


    const categoryMenuItems = useMemo(() => {
        if (!menuStructure.length) return [];
        return menuStructure.map((section) => ({
            label: section.name,
            className: currentCollection === section.name ? "catalog-category-active" : "",
            ...(section.groups?.length === 0 ? {
                command: () => {
                    const path = buildCatalogPath({
                        collection: section.name,
                        menuStructure,
                    });
                    onNavigate?.(path);
                },
            } : {}),
            ...(section.groups?.length ? {
                items: section.groups.map((group) => ({
                    label: group.title,
                    className: currentCollection === section.name && currentSubcollection === group.title
                        ? "catalog-category-active" : "",
                    
                    ...(group.items?.length === 0 ? {
                        command: () => {
                            const path = buildCatalogPath({
                                collection: section.name,
                                subcollection: group.title,
                                familyId: group.id,
                                menuStructure,
                            });
                            onNavigate?.(path);
                        },
                    } : {}),
            
                    ...(group.items?.length ? {
                        items: group.items.map((item) => ({
                            label: item.name,
                            className: currentCollection === section.name && currentSubcollection === item.name
                                ? "catalog-category-active" : "",
                            command: () => {
                                const path = buildCatalogPath({
                                    collection: section.name,
                                    subcollection: item.name,
                                    familyId: item.id,
                                    menuStructure,
                                });
                                onNavigate?.(path);
                            },
                        })),
                    } : {}),
                })),
            } : {}),
        }));
    }, [menuStructure, currentCollection, currentSubcollection, onNavigate]);

    return (
    <aside className="catalog-sidebar">
        <Panel
            header="Filtros"
            className="catalog-sidebar-panel"
            icons={hasActiveFilters ? (
                <Button
                    className="catalog-sidebar-clear p-button p-component p-button-text p-button-sm"
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onClear?.();
                    }}
                    label="Limpiar"
                />
            ) : null}
        >
        <div className="catalog-filter-section">
            <span className="catalog-filter-section-title">Categorías</span>
            <PanelMenu
                key={`${currentCollection}-${currentSubcollection}`}
                model={categoryMenuItems}
            />
        </div>

        <div className="catalog-filter-section">
            <div className="catalog-filter-group">
                <span className="catalog-filter-label">Rango de precio</span>
                <div className="catalog-filter-range">
                <InputText
                    keyfilter="int"
                    className="p-inputtext-sm"
                    value={priceMin}
                    onChange={(event) => onPriceMinChange?.(event.target.value)}
                    placeholder="Mínimo"
                />
                <InputText
                    keyfilter="int"
                    className="p-inputtext-sm"
                    value={priceMax}
                    onChange={(event) => onPriceMaxChange?.(event.target.value)}
                    placeholder="Máximo"
                />
                </div>
            </div>

            <div className="catalog-filter-check">
                <Checkbox
                    label="Solo con stock"
                    inputId="filter-stock"
                    checked={onlyInStock}
                    onChange={(event) => onOnlyInStockChange?.(Boolean(event.checked))}
                />
                <label>Solo con stock</label>

                <Checkbox
                    label="Solo con descuento"
                    inputId="filter-discount"
                    checked={onlyDiscounted}
                    onChange={(event) => onOnlyDiscountedChange?.(Boolean(event.checked))}
                />
                <label>Solo con descuento</label>
            </div>
        </div>

        {showDynamicAttributes ? (
            <div className="catalog-filter-section">
            <span className="catalog-filter-section-title">Atributos</span>
            {attributesLoading ? <p className="catalog-sidebar-empty">Cargando atributos...</p> : null}
            {!attributesLoading && attributesError ? <p className="catalog-sidebar-empty">{attributesError}</p> : null}
            {!attributesLoading && !attributesError && attributeGroups.map((attribute) => (
                <div key={attribute.id} className="catalog-filter-group">
                <span className="catalog-filter-label">{attribute.llave}</span>
                <div className="catalog-filter-options">
                    {(attribute.valores || []).map((option) => (
                    <div key={option.id} className="catalog-filter-check">
                        <Checkbox
                            inputId={`attr-${attribute.id}-${option.id}`}
                            checked={Boolean(selectedAttributeFilters?.[attribute.id]?.includes(option.id))}
                            onChange={(event) => onAttributeToggle?.({ attributeId: attribute.id, valueId: option.id, checked: Boolean(event.checked) })}
                        />
                        <label htmlFor={`attr-${attribute.id}-${option.id}`}>{option.valor}</label>
                    </div>
                    ))}
                </div>
                </div>
            ))}
            {!attributesLoading && !attributesError && !attributeGroups.length ? <p className="catalog-sidebar-empty">Esta familia no tiene atributos disponibles.</p> : null}
            </div>
        ) : null}
        </Panel>
    </aside>
    );
};

export default CatalogFiltersSidebar;